import Http from '@/api/http'
let h = new Http().create()
let domain = new Http().upload()
export const userLogin = d => h.post('/login/toLogin.do', d) //登录
export const listAreaInfo = d => h.post('/common/listAreaInfo.do', d) //查询省市区
export const queryStaffVoice = d => h.post('/staff/queryStaffVoice.do', d) //查询语音开启状态
export const oeprateStaffVoice = d => h.post('/staff/operateStaffVoice.do', d) //修改语音开启状态
// 老板
export const selectStore = d => h.post('/store/selectStore.do', d) //登录
export const outStore = d => h.post('/store/outStore.do', d) //老板登出门店
export const toLoginOut = d => h.post('/login/toLoginOut.do', d) //登出系统
// 会员
export const searchMem = d => h.post('/member/queryMemberOffline.do', d) //查询会员
export const searchOrgan = d => h.post('/member/queryOrgan.do', d) //查询完善部位字典表
export const insertMem = d => h.post('/member/insertMember.do', d) //插入会员
export const updateMemPsd = d => h.post('/member/updateMemberOffPassword.do', d) //更改会员消费密码
export const sendCode = d => h.post('/common/sendCode.do', d) //发送短信验证码
export const memDetail = d => h.post('/member/queryMemberOfflineDetailInfo.do', d) //查询会员详细信息
export const updateMem = d => h.post('/member/updateMember.do', d) //更新会员信息
export const insertAccount = d => h.post('/member/insertAccountOff.do', d) //加入本店会员
export const insertMemRecharge = d => h.post('/member/insertMemberRecharge.do', d) //会员充值
export const queryRechargePage = d => h.post('/member/queryRechargePage.do', d) //分页查询会员充值列表
export const exportChargeList = domain + '/member/exportChargeList.xls' //拉取查询会员充值列表
export const queryMemberOfflineForSearch = d => h.post('/member/queryMemberOfflineForSearch.do', d) //收银界面模糊搜索会员

export const queryMemberBirthInfo = d => h.post('/member/queryMemberBirthInfo.do', d) //查询指定时间段过生日的会员
export const queryMemberBirthPage = d => h.post('/member/queryMemberBirthPage.do', d) //分页查询指定时间段过生日的会员
export const refundAccountOff = d => h.post('/member/refundAccountOff.do', d) //会员充值退款
export const queryRefundAmountList = d => h.post('/member/queryRefundAmountList.do', d) //分页查询会员充值退款
export const exportRefundList = domain + '/member/exportRefundList.xls' //查询会员充值退款excel
// 员工
export const searchStaff = d => h.post('/staff/queryStaffList.do', d) //查询员工列表
export const staffInfo = d => h.post('/staff/queryStaffInfo.do', d) //查询员工详细信息
export const queryStaffPhoneByStaffId = d => h.post('/staff/queryStaffPhoneByStaffId.do', d) //查询员工详细信息
export const insertStaff = d => h.post('/staff/insertStaff.do', d) //添加员工
export const updateStaff = d => h.post('/staff/updateStaff.do', d) //修改员工信息
export const updateStaffPsd = d => h.post('/staff/updateStaffPwd.do', d) //修改员工登录密码
export const resetStaffPsd = d => h.post('/staff/resetStaffPwd.do', d) //重置员工登录密码
// 基础设置
export const storeInfo = d => h.post('/store/queryStoreInfo.do', d) //查询店家信息
export const updateStore = d => h.post('/store/updateStore.do', d) //修改店家信息
export const deleteFiles = d => h.post('/common/deleteFileByFlag.do', d) //上传文件删除
export const uploadUrl = domain + '/common/saveFile.do'; //上传文件
// 报修
export const addDeviceFix = d => h.post('/logistics/addDeviceFix.do', d) //添加仪器维修信息
export const fixLists = d => h.post('/logistics/queryFixList.do', d) //查询报修列表
// 商品售卖管理
export const searchServiceVoucher = d => h.post('/goods/queryServiceBaseAndReviseList.do', d) //查询服务基础信息和线上信息列表
export const ServiceInfos = d => h.post('/goods/queryServiceInfo.do', d) //查询线上服务详情
export const updateStatus = d => h.post('/goods/updateServiceReviseSaleStatus.do', d) //服务上下架
export const updateAudStatus = d => h.post('/goods/updateServiceReviseAudStatus.do', d) //提交审核/取消提交审核
export const deleteStatus = d => h.post('/goods/deleteRevise.do', d) //删除
export const allServiceList = d => h.post('/goods/queryAllServiceList.do', d) //查询全部基础服务列表
export const allServiceProList = d => h.post('/goods/querySystemProduction.do', d) //查询系统基础产品
export const allServiceSubList = d => h.post('/goods/queryBrandServicesByAddType.do', d) //查询系统基础产品

// 体验券
export const insertVoucher = d => h.post('/goods/insertServiceBaseAndRevise.do', d) //添加体验券
export const updateVoucher = d => h.post('/goods/updateServiceBaseAndRevise.do', d) //修改体验券
export const updateSort = d => h.post('/goods/updateServiceBaseAndReviseSorting.do', d) //修改体验券排序
// 服务项目
export const insertService = d => h.post('/goods/insertServiceRevise.do', d) //添加基础服务线上信息
export const updateService = d => h.post('/goods/updateServiceRevise.do', d) //修改基础服务线上信息

//门店商城
export const selectDict = d => h.post('/dict/selectDict', d) //数据字典：1系统类别 2产品类别 3退货地址
export const listProductAll = d => h.post('/product/listProductAllByPageForTM', d) //首页产品展示，产品展示
export const selectShopCar = d => h.post('/shopCar/selectShopCar', d) //购物车
export const addProductCar = d => h.post('/shopCar/addProduct', d) //添加购物车
export const deleteProductCar = d => h.post('/shopCar/deleteProduct', d) //删除购物车商品
export const getProductDetailsByIdForTM = d => h.post('/product/getProductDetailsByIdForTM', d)//查看商品详情
export const selectReceiverAddress = d => h.post('/order/selectReceiverAddress', d)//查看收货地址
export const submitOrder = d => h.post('/order/submitOrder', d)//提交订单
export const selectAllOrders = d => h.post('/order/selectAllOrders', d)//订单列表页
export const viewOrderDetails = d => h.post('/order/viewOrder', d)//查看订单
export const cancelOrder = d => h.post('/order/cancelOrder', d)//取消订单
export const confirmReceipt = d => h.post('/order/confirmReceipt', d)//确认收货
export const viewLogistics = d => h.post('/order/viewLogistics', d)//查看物流
export const applyForAfterSale = d => h.post('/order/applyForAfterSale', d)//申请售后
export const selectAfterSaleOrders = d => h.post('/order/selectAfterSaleOrders', d)//售后单列表
export const selectReplaceAndReturnOrders = d => h.post('/order/selectReplaceAndReturnOrders', d)//补发，退货单
export const viewAfterSalesOrder = d => h.post('/order/viewAfterSalesOrder', d)//补发，退货单
export const viewReturnProductAddress = d => h.post('/order/viewReturnProductAddress', d)//查看退货地址
export const selectAllLogisticsCompany = d => h.post('/order/selectAllLogisticsCompany', d)//查询所有物流公司
export const confirmShipment = d => h.post('/order/confirmShipment', d)//确认收货

// 消费密码
export const checkDiscountKey = d => h.post('/store/checkDiscountKey.do', d) //验证店家折扣口令
export const checkMemAccountPwd = d => h.post('/member/checkMemberAccountPwdOff.do', d) //验证会员消费密码
// 员工权限
export const allStaffStatus = d => h.post('/staff/selectStaffByStatus', d) //查询员工分配权限的员工列表，无分页，无参数
export const selectResource = d => h.post('/resource/selectResource', d) //查询所有菜单权限
export const getByUserId = d => h.post('/resource/getByUserId', d) //获取某个员工拥有的菜单权限
export const getByUserIdNoTree = d => h.post('/resource/getByUserIdWithNoTree', d) //查询员工拥有的菜单权限（不转换为tree结构）
export const authorize = d => h.post('/staff/authorize', d) //修改用户权限
export const queryAllSettlementList = d => h.post('/settle/queryAllSettlementList.do', d) //结算权限设置列表获取
export const updateSettle = d => h.post('/settle/updateSettle.do', d) //设置员工结算权限
// 提成
export const manualFee = d => h.post('/fee/queryManualFee.do', d) //查询基本手工费
export const operateManualFee = d => h.post('/fee/operateManualFee.do', d) //新增基本手工费
export const feeSetList = d => h.post('/fee/queryFeeSetList.do', d) //查询提成设置
export const insertFeeSet = d => h.post('/fee/insertFeeSet.do', d) //新增销售/服务销售奖励提成
export const updateFeeSet = d => h.post('/fee/updateFeeSet.do', d) //修改销售/服务销售奖励提成
export const queryHomeFee = d => h.post('/fee/queryHomeFee.do', d) //查询上门费
export const operateHomeFee = d => h.post('/fee/operateHomeFee.do', d) //新增/修改上门费费
export const queryManualFeeList = d => h.post('/fee/queryManualFeeList.do', d) //查询手工费提成4.1
export const queryStoreFeeList = d => h.post('/fee/queryStoreFeeList.do', d) //查询销售/服务销售奖励提成4.1
export const updateStoreFee = d => h.post('/fee/updateStoreFee.do', d) //修改销售/服务销售奖励提成4.1
export const insertStoreFee = d => h.post('/fee/insertStoreFee.do', d) //新增销售/服务销售奖励提成4.1
export const queryGoodsFee = d => h.post('/goods/queryGoodsFee.do', d) //查询门店提成给定设置
export const operateGoodsFee = d => h.post('/goods/operateGoodsFee.do', d) //门店操作提成给定设置

// 报表
export const queryStaffFee = d => h.post('/fee/queryStaffFee.do', d) //查询员工个人提成
export const queryStaffTeamFee = d => h.post('/fee/queryStaffTeamFee.do', d) //查询员工团队提成
export const pageOrderServeVisitMoney = d => h.post('/serviceOrder/pageOrderServeVisitMoney.do', d) //分页查询上门费
export const pageOrderServeManualFee = d => h.post('/serviceOrder/pageOrderServeManualFee.do', d) //分页查询手工费
export const exportOrderServeVisitMoneyList = domain + '/serviceOrder/exportOrderServeVisitMoneyList.xls' //查询上门费excel
export const exportOrderServeManualFeeList = domain + '/serviceOrder/exportOrderServeManualFeeList.xls' //查询手工费excel
export const pageCashierDiscount = d => h.post('/saleOrder/pageCashierDiscount.do', d) //分页查询收银员让利
export const exportPageCashierDiscountList = domain + '/saleOrder/exportCashierDiscountList.xls' //导出收银员让利excel
export const pageOrderServePickPrice = d => h.post('/serviceOrder/pageOrderServePickPrice.do', d) //分页查询服务消耗业绩
export const exportOrderServePickPriceList = domain + '/serviceOrder/exportOrderServePickPriceList.xls' //查询服务消耗业绩excel
export const pageStaffSaleInfo = d => h.post('/saleOrder/pageStaffSaleInfo.do', d) //分页查询员工销售业绩
export const exportStaffSaleInfoList = domain + '/saleOrder/exportStaffSaleInfoList.xls' //导出员工销售业绩excel
export const pageOrderGoodsReturnAll = d => h.post('/saleOrder/pageOrderGoodsReturnAll.do', d) //分页查询员工退货信息
export const exportOrderGoodsReturnList = domain + '/saleOrder/exportOrderGoodsReturnList.xls' //导出员工退货信息ecxel
export const pageMemberOrderGoodsDetails = d => h.post('/saleOrder/pageMemberOrderGoodsDetails.do', d) //分页查询会员订单中的服务使用情况
export const pageMemberServiceChanges = d => h.post('/serviceOrder/pageMemberServiceChanges.do', d) //分页查询会员服务变动列表
export const exportMemberOrderGoodsDetails = domain + '/saleOrder/exportMemberOrderGoodsDetails.xls' //导出会员订单中的服务使用情况
export const newsQueryStaf = d => h.post('/accountCheck/queryStaffList.do', d) //获取当前门店下所有人员信息列表
export const newsQueryRecon = d => h.post('/accountCheck/queryReconciliation.do', d) //门店查询现金流总收支（销售收支+ 充值收支）
export const newsReconcilia = d => h.post('/accountCheck/queryReconciliationSales.do', d) //销售收支
export const newsTionTopUp = d => h.post('/accountCheck/queryReconciliationTopUp.do', d) //充值收支

// 订单 服务单
export const addSaleOrder = d => h.post('/saleOrder/addSaleOrder.do', d)//创建订单 结算
export const saleOrderList = d => h.post('/saleOrder/querySaleOrderList.do', d)//订单列表
export const saleOrderInfo = d => h.post('/saleOrder/querySaleOrderInfo.do', d)//订单列表
export const serviceOrderList = d => h.post('/serviceOrder/queryServiceOrderList.do', d)//服务单列表
export const technicianList = d => h.post('/serviceOrder/queryTechnicianList.do', d)//技师空闲状态列表
export const memberServiceList = d => h.post('/member/queryMemberServiceList.do', d)//会员剩余项目列表
export const addServiceOrder = d => h.post('/serviceOrder/addServiceOrder.do', d)//创建服务单
export const endOrderServe = d => h.post('/serviceOrder/endOrderServe.do', d)//结束服务单
export const insertManualAssign = d => h.post('/serviceOrder/insertManualAssignTechnician.do', d)//人工派单
export const transferOrder = d => h.post('/serviceOrder/insertTransferOrderServe.do', d)//转单
export const startOrderServe = d => h.post('/serviceOrder/startOrderServe.do', d)//开始服务单
export const appointNextOrderServe = d => h.post('/serviceOrder/appointNextOrderServe.do', d)//设置下次服务
export const cancelServiceOrder = d => h.post('/serviceOrder/cancelServiceOrder.do', d)//取消服务单
export const getOrderServeDetails = d => h.post('/serviceOrder/queryServiceOrderInfo.do', d)//服务单详情
export const exportSaleOrderList = domain + '/saleOrder/exportSaleOrderList.xls' //导出订单列表
export const refundSaleOrder = d => h.post('saleOrder/refundSaleOrder.do', d)//退货
export const getOrderGoodsReturnByGoodsDetailsId = d => h.post('/saleOrder/getOrderGoodsReturnDetailsByGoodsDetailsId.do', d)//根据订单商品详情id获取退货单信息

// 挂单
export const insertRestOrder = d => h.post('/saleOrder/insertRestOrder.do', d)//新增挂单信息
export const deleteRestOrder = d => h.post('/saleOrder/deleteRestOrder.do', d)//删除挂单信息
export const queryRestOrder = d => h.post('/saleOrder/queryRestOrder.do', d)//查询挂单信息
// 库存
// export const queryStockList = d => h.post('/stock/queryStockList.do', d)//分页查询库存列表
// export const queryStockDetail = d => h.post('/stock/queryStockDetail.do', d)//分页查询库存变动详细列表
// export const insertApplyToSmall = d => h.post('/stock/insertApplyToSmall.do', d)//公共套盒申请
// export const updateStock = d => h.post('/stock/updateStock.do', d)//库存调整
// export const exportStockDetailList = domain + '/stock/exportStockDetailList.xls' //导出会员线下门店库存变动信息excel
// 零售商品
// export const queryStoreProductPage = d => h.post('/goods/queryStoreProductPage.do', d)//分页查询店家自定义的实体商品内容
// export const operateStoreProduct = d => h.post('/goods/operateStoreProduct.do', d)//新增/修改店家自定义实体商品的内容
export const queryStoreProductDetailPage = d => h.post('/goods/queryStoreProductDetailPage.do', d)//分页查询指定productId的定义变动情况
export const querySaleProductList = d => h.post('/goods/querySaleProductList.do', d)//店家收银台查询实体商品内容
// 集团业务
export const selectAllApplyOrders = d => h.post('/inn/selectAllApplyOrders', d)//获取门店申请下店列表
export const submitApplyOrder = d => h.post('/inn/submitApplyOrder', d)//门店提交新增申请
export const innAssistEvaluation = d => h.post('/inn/innAssistEvaluation', d)//门店对协助人评价
export const viewInnOrder = d => h.post('/inn/viewInnOrder', d)//门店对协助人评价
export const cancleApplyOrder = d => h.post('/inn/cancleApplyOrder', d)//门店取消申请订单
export const signIn = d => h.post('/inn/signIn', d)//老师下店签到
export const signBack = d => h.post('/inn/signBack', d)//老师离店签退
//新的商品管理
export const queryServicePageList = d => h.post('/store/queryServicePageList.do', d) //获取单次/整套服务/零售商品分页列表数据
export const updateServiceStatus = d => h.post('/store/updateServiceStatus.do', d) //服务项目上下架
export const deleteServiceBase = d => h.post('/store/deleteServiceBase.do', d) //删除单次、整套、零售商品
export const insertServiceBase = d => h.post('/store/insertServiceBase.do', d) //新增单次/整套服务/零售商品
export const viewServiceBase = d => h.post('/store/viewServiceBase.do', d) //查看单次/整套服务/零售商品详情
export const updateServiceBase = d => h.post('/store/updateServiceBase.do', d) //更新单次/整套服务/零售商品
export const selectDCStoreServiceList = d => h.post('/adjust/selectDCStoreServiceList.do', d) //获取整套服务列表数据
export const selectDCANDXNStoreServiceList = d => h.post('/adjust/selectDCANDXNStoreServiceList.do', d) //获取整套服务列表数据
export const queryPackagePageList = d => h.post('/storePackage/queryPackagePageList.do', d) //分页获取体验劵、套餐、任选套餐列表
export const updatePackageStatus = d => h.post('/storePackage/updatePackageStatus.do', d) //分页获取体验劵、套餐、任选套餐列表
export const deletePackageBase = d => h.post('/storePackage/deletePackageBase.do', d) //删除体验劵、套餐、任选套餐
export const insertPackageBase = d => h.post('/storePackage/insertPackageBase.do', d) //新增体验券、套餐、任选套餐
export const selectZTLSStoreServiceList = d => h.post('/adjust/selectZTLSStoreServiceList.do', d) //获取整套、零售商品列表
export const viewPackageBase = d => h.post('/storePackage/viewPackageBase.do', d) //查看体验券、套餐、任选套餐详情
export const updatePackageBase = d => h.post('/storePackage/updatePackageBase.do', d) //更新体验劵、套餐、任选套餐
export const getPackageCount = d => h.post('/storePackage/getPackageCount.do', d) //获取各类型数量
export const getStoreServiceCount = d => h.post('/store/getStoreServiceCount.do', d) //获取各数量
export const queryInventoryAdjustPageList = d => h.post('/adjust/queryInventoryAdjustPageList.do', d) //单次、整套、零售商品库存监管
export const adjustStoreServiceCount = d => h.post('/adjust/getStoreServiceCount.do', d) //获取各数量
export const adjustInventory = d => h.post('/adjust/adjustInventory.do', d) //单次、整套、零售商品库存调整
export const adjStockDetail = d => h.post('/stock/queryStockDetail.do', d) //单次、整套、零售商品库存出入记录
export const adjustDetailList = domain + '/adjust/exportStockDetailList.xls' //单次、整套、零售商品库存导出
export const commodityWarehousing = d => h.post('/adjust/commodityWarehousing.do', d) //整套服务、零售商品入库操作
export const storeServiceBreakUp = d => h.post('/adjust/storeServiceBreakUp.do', d) //整套服务拆分
export const stockTakingList = d => h.post('/stock/queryStockTakingList.do', d)//分页查询盘点信息列表
export const stockTakingInfo = d => h.post('/stock/queryStockTakingInfo.do', d)//查询盘点详细信息
export const allStaff = d => h.post('/staff/queryAllStaffList.do', d) //查询所有员工列表
export const insertStockTaking = d => h.post('/stock/insertStockTaking.do', d)//库存盘点
export const exportStockTakingList = domain + '/stock/exportStockTakingList.xls' //导出盘点excel
export const queryAllStockList = d => h.post('/stock/queryAllStockList.do', d)//查询库存列表
export const templateDownLoad = domain + '/member/templateDownLoad.do' //会员模板下载
export const importMembers = domain + '/member/importMembers.do'; //会员批量导入（excel文件）
export const updatrMemberRemainingServicesNumber = d => h.post('/saleOrder/updatrMemberRemainingServicesNumber.do', d)//整会员服务次数
export const getPackageChildBase = d => h.post('/storePackage/getPackageChildBase.do', d)//收银台服务次数
export const memberServicesRemaining = d => h.post('/saleOrder/memberServicesRemaining.do', d)//会员余量
export const selectXNStoreServiceList = d => h.post('/adjust/selectXNStoreServiceList.do', d)//虚拟商品
export const importMembersOther = domain + '/member/importMembersOther.do'; //槑博士会员批量导入（excel文件）
export const templateDownLoadOther = domain + '/member/templateDownLoadOther.do'; //槑博士会员下载模板
//营收监控
export const getBasicInfos = d => h.post('/reven/getBasicInfos.do', d)//营收监控基础信息获取
export const getSalesTrends = d => h.post('/reven/getSalesTrends.do', d)//营收监控年月日销售额趋势数据获取
export const getStoreSalesRanks = d => h.post('/reven/getStoreSalesRanks.do', d)//营收监控门店销售额数据获取
export const getBrandSales = d => h.post('/reven/getBrandSales.do', d)//品牌销售占比
export const getCategorySales = d => h.post('/reven/getCategorySales.do', d)//品类销售占比


// WEBPACK FOOTER //
// ./src/api/index.js